<div class="modal-dialog-centered modal-login">
  <div class="modal-content">
    <div class="modal-body">
      <div>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="bsModalRef.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="row">
          <div class="col-xl-6">
            <ul id="tabs" class="nav nav-justified nav-tabs-custom">
              <li class="nav-item"><a href="" data-target="#home1" data-toggle="tab" class="nav-link active">
                  {{"會員登入" | translate}}</a>
              </li>
              <li class="nav-item"><a href="" data-target="#profile1" data-toggle="tab" class="nav-link">
                  {{"會員註冊" | translate}}</a>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div id="home1" class="tab-pane fade active show">
                <div>
                  <small>
                    {{"若你是從LINE開啟本網站，因LINE會阻擋外部社群帳號登入，請複製本網址後，再貼到你慣用的瀏覽器打開。即可正常註冊/登入" | translate}}
                  </small>

                  <div class="input-group input-group-sm mt-2 mb-4">
                    <input type="text" class="form-control" aria-describedby="" value="https://www.eztogo.tw"
                      readonly="">
                    <div class="input-group-append">
                      <button type="submit" class="btn btn-success" (click)="copyToClipboard()">
                        <span><i class="bi bi-search"></i>{{"複製" | translate}}</span>
                      </button>
                    </div>
                  </div>
                </div>

                <h6 class="text-center">{{"社群帳號登入" | translate}}</h6>
                <div class="social-media-buttons">
                  <!-- <div class="icon">
                    <a (click)="facebookLogin()">
                      <svg viewBox="0 0 24 24">
                        <path fill="#1778F2"
                          d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm3 8h-1.35c-.538 0-.65.221-.65.778v1.222h2l-.209 2h-1.791v7h-3v-7h-2v-2h2v-2.308c0-1.769.931-2.692 3.029-2.692h1.971v3z" />
                      </svg>
                      <div>Facebook</div>
                    </a>
                  </div> -->
                  <div class="icon">
                    <a (click)="googleLogin()" class="clickable">
                      <img width="24"
                        src="data:image/png;base64,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" />
                      <div>Google</div>
                    </a>
                  </div>

                </div>
                <div class="title-gap">
                  <span>OR</span>
                </div>
                <div *ngIf="!showForget">
                  <form id="sign-in-form" [formGroup]="loginForm" (ngSubmit)="accountLogin()">
                    <h6 class="text-center">{{"帳號登入" | translate}}</h6>
                    <div class="form-wrapper">
                      <i class="material-icons-outlined">mail</i>
                      <input type="email" name="email" class="form-control" placeholder="Email" formControlName="email"
                        [ngClass]="{ 'is-invalid': lf.email.errors && lf.email.touched }">
                      <span *ngIf="lf.email.errors?.required" class="invalid-feedback">Email{{"為必填" | translate}}</span>
                      <span *ngIf="lf.email.errors?.email" class="invalid-feedback">
                        {{"請填入正確的Email格式" | translate}}</span>
                    </div>
                    <div class="form-wrapper">
                      <i class="material-icons-outlined">vpn_key</i>
                      <input class="form-control" type="password" [placeholder]="'密碼' | translate"
                        formControlName="pswd" [ngClass]="{ 'is-invalid': lf.pswd.errors && lf.pswd.touched }" />
                      <span *ngIf="lf.pswd.errors?.required" class="invalid-feedback">
                        {{"密碼" | translate}}{{"為必填" | translate}}</span>
                      <span *ngIf="lf.pswd.errors?.minlength" class="invalid-feedback">
                        {{"密碼長度須大於6" | translate}}</span>
                    </div>
                    <a class="forgot-password float-right clickable" (click)="showForget=true">{{"忘記密碼" | translate}}？</a>
                    <button type="submit" class="btn btn-block btn-primary btn-lg" [disabled]="!loginForm.valid">
                      {{"登入" | translate}}</button>
                  </form>
                </div>
                <div *ngIf="showForget">
                  <form id="sign-in-form" [formGroup]="emailForm" (ngSubmit)="forgetPswd()">
                    <h6 class="text-center">{{"忘記密碼" | translate}}</h6>
                    <div class="form-wrapper">
                      <i class="material-icons-outlined">mail</i>
                      <input type="email" name="email" class="form-control" placeholder="Email" formControlName="email"
                        [ngClass]="{ 'is-invalid': ef.email.errors && ef.email.touched }">
                      <span *ngIf="ef.email.errors?.required" class="invalid-feedback">Email{{"為必填" | translate}}</span>
                      <span *ngIf="ef.email.errors?.email" class="invalid-feedback">
                        {{"請填入正確的Email格式" | translate}}</span>
                    </div>
                    <a class="forgot-password float-right clickable" (click)="showForget=false">{{"會員登入" | translate}}</a>
                    <button type="submit" class="btn btn-block btn-primary btn-lg"
                      [disabled]="!emailForm.valid">{{"重新設定密碼" | translate}}</button>
                  </form>
                </div>
              </div>

              <div id="profile1" class="tab-pane fade">
                <div>
                  <small>
                    {{"若你是從LINE開啟本網站，因LINE會阻擋外部社群帳號登入，請複製本網址後，再貼到你慣用的瀏覽器打開。即可正常註冊/登入" | translate}}
                  </small>

                  <div class="input-group input-group-sm mt-2 mb-4">
                    <input type="text" class="form-control" aria-describedby="" value="https://www.eztogo.tw"
                      readonly="">
                    <div class="input-group-append">
                      <button type="submit" class="btn btn-success" (click)="copyToClipboard()">
                        <span><i class="bi bi-search"></i>{{"複製" | translate}}</span>
                      </button>
                    </div>
                  </div>
                </div>


                <h6 class="text-center">{{"會員註冊" | translate}}</h6>
                <div class="social-media-buttons">
                  <!-- <div class="icon">
                    <a (click)="facebookLogin()">
                      <svg viewBox="0 0 24 24">
                        <path fill="#1778F2"
                          d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm3 8h-1.35c-.538 0-.65.221-.65.778v1.222h2l-.209 2h-1.791v7h-3v-7h-2v-2h2v-2.308c0-1.769.931-2.692 3.029-2.692h1.971v3z" />
                      </svg>
                      <div>Facebook</div>
                    </a>
                  </div> -->
                  <div class="icon">
                    <div>
                      <a (click)="googleLogin()" class="clickable">
                        <img width="24"
                          src="data:image/png;base64,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" />
                      </a>
                    </div>
                    <div>Google</div>
                  </div>
                </div>
                <div class="title-gap">
                  <span>OR</span>
                </div>
                <form id="sign-in-form" [formGroup]="form" (ngSubmit)="register()">
                  <h6 class="text-center">{{"會員註冊" | translate}}</h6>
                  <div class="form-wrapper">
                    <i class="material-icons-outlined">mail</i>
                    <input type="email" name="email" class="form-control" placeholder="Email" formControlName="email"
                      [ngClass]="{ 'is-invalid': f.email.errors && f.email.touched }">
                    <span *ngIf="f.email.errors?.required" class="invalid-feedback">Email{{"為必填" | translate}}</span>
                    <span *ngIf="f.email.errors?.email" class="invalid-feedback">{{"請填入正確的Email格式" |
                      googleTranslate:true | async}}</span>
                  </div>
                  <div class="form-wrapper">
                    <i class="material-icons-outlined">vpn_key</i>
                    <input class="form-control" type="password" [placeholder]="'密碼' | translate" formControlName="pswd"
                      [ngClass]="{ 'is-invalid': f.pswd.errors && f.pswd.touched }" />
                    <span *ngIf="f.pswd.errors?.required" class="invalid-feedback">{{"密碼為必填" | translate}}</span>
                    <span *ngIf="f.pswd.errors?.minlength" class="invalid-feedback">{{"密碼長度須大於6" | translate}}</span>
                  </div>

                  <div class="form-wrapper my-3">
                    <!-- <img src="images/recaptcha.png" alt="" class="img-fluid"> -->
                    <ngx-recaptcha2 #captchaElem [siteKey]="siteKey" (reset)="handleReset()" (expire)="handleExpire()"
                      (load)="handleLoad()" (success)="handleSuccess($event)" [useGlobalDomain]="false" [size]="size"
                      [hl]="lang" [theme]="theme" [type]="type" formControlName="recaptcha">
                    </ngx-recaptcha2>
                  </div>
                  <button type="submit" class="btn btn-block btn-primary btn-lg" [disabled]="!form.valid">
                    {{"註冊" | translate}}</button>
                </form>
              </div>

            </div>
          </div>
          <div class="col-xl-6 overlay d-none d-xl-block">
            <div class="modal-logo"></div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
